export default __webpack_public_path__ + "static/media/04n.3d82b4cb.svg";